export class ADM0008Class {

    FavoriteId:number;
    FkUserId:number;
    FkMenuId:number;
    PageName:string;
    Category:number;
    CrtdOn:Date;
    PageUrl :string;
    //////////////////////////////
   
}
